import { getContent } from '@/utils/helper';

import { Cta } from './Cta';

function CtfCta({
  entries,
  field,
  invert,
  noWrap,
  hideIcon,
  onClick,
  size,
  isWhiteCta,
  className,
}) {
  if (!field) {
    return null;
  }

  const cta = getContent(field.sys?.id, entries);
  if (!cta) {
    return null;
  }

  const {
    name,
    link,
    page: pageField,
    icon,
    style: type,
    reloadPage,
    hasIconBorder,
  } = cta.fields || {};
  const page = pageField
    ? getContent(pageField.sys.id, entries)?.fields?.slug
    : null;

  return (
    <Cta
      isWhiteCta={isWhiteCta}
      iconProps={{
        hasIconBorder,
        height: 15,
        hideIcon,
        name: icon,
        width: 15,
        style:
          'text-acacia dd-kr:text-actual-dd-gold dd-en:text-actual-dd-gold',
      }}
      buttonProps={{
        name,
        type,
        style: `${className} ${noWrap ? 'w-max' : 'w-fit'}`,
        invert,
        size,
      }}
      linkProps={{
        url: link,
        page,
        reloadPage,
      }}
      onClick={onClick}
    />
  );
}

export default CtfCta;
